import { Loading } from '@softwareimaging/react';
import { FC, useEffect } from 'react';
import { useSignInUp } from '../../services/authentication/hooks/auth';

import { useLocation } from 'react-router-dom';
import { Meta } from '../../lib/meta';

export const SignIn: FC = () => {
  const signIn = useSignInUp();
  const location = useLocation();

  useEffect(() => {
    const from = location.state?.from;
    signIn(from);
  }, [signIn]);

  return (
    <>
      <Meta title="Sign in" />
      <Loading className="h-screen" />
    </>
  );
};
